export default [
    {
        path: '/:cid/preview',
        name: 'PreviewAttachments',
        meta: {
            title: "PreviewAttachments",
            requiresAuth: true,
            lightweight: true,
            hideHeader: true,
            preventAdvanceSearch: true
        },
        component: () => import('@/views/PreviewAttachments/PreviewAttachments.vue'),
    },
]
